import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { Loading, Timer } from "@element-plus/icons-vue";
import MockMenuBox from "@/components/exam/MockMenuBox.vue";
import pwco from "@/components/examItem/item-pwco";
import sequencing from "@/components/examItem/item-sequencing.vue";
import mcq from "@/components/examItem/item-mcq.vue";
import vocabulary_mcq from "@/components/examItem/item-vocabulary-mcq.vue";
import saq from "@/components/examItem/item-saq.vue";
import mm_sequencing from "@/components/examItem/item-mm-sequencing.vue";
import mm from "@/components/examItem/item-mm.vue";
import mm_drag from "@/components/examItem/item-mm-drag.vue";
import mm_mcq from "@/components/examItem/item-mm-mcq.vue";
import writing from "@/components/examItem/item-writing.vue";
import proofreading from "@/components/examItem/item-proofreading.vue";
import mcq_mmcq from "@/components/examItem/item-mcq-mmcq.vue";
import writing_listen from "@/components/examItem/item-writing-listen.vue";
import { audioUrl } from "@/env.js";
import { reactive, ref, nextTick, watch, onBeforeUnmount } from "vue";
import { GetResumeApi, SetResumeApi, SubmitExamApi } from "@/api/examApi.js";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
let examId = "";
export default {
  components: {
    mm_sequencing,
    MockMenuBox,
    pwco,
    sequencing,
    mcq,
    saq,
    vocabulary_mcq,
    mm,
    mm_drag,
    mm_mcq,
    writing,
    proofreading,
    mcq_mmcq,
    writing_listen
  },
  props: ["examInfo", "netState"],
  setup(props, content) {
    //试卷为数组
    let paperInfo = reactive([]);
    let itemNo = ref(0);
    let paperNo = ref(0);
    let cache = reactive({});
    let totalQuestion = ref(0);
    let store = useStore();
    examId = props.examInfo.examId + "";
    //试卷
    let {
      getPaper
    } = usePaper(paperInfo, totalQuestion, props.examInfo, store);
    //缓存
    let {
      getResume,
      setAnswer,
      setcache
    } = useAnswer(cache, getPaper, props.examInfo, itemNo, paperNo, props.netState, content);
    //流程
    let {
      timeText,
      setCountDown,
      finishExam
    } = useExamProcess(props.examInfo, content, cache, setcache, totalQuestion, paperNo, paperInfo);
    let {
      paperNo_S1,
      preLoadingText,
      preLoading,
      preLoad,
      audioStatus,
      audioPlay,
      audioEnded,
      setAudioStatus,
      updateCache,
      saveAudioTime
    } = useAudio(paperInfo, itemNo, cache, setcache, paperNo);
    getResume(setCountDown, preLoad);
    watch(props.netState, () => {
      setCountDown();
    });
    //听力功能

    return {
      paperNo_S1,
      preLoadingText,
      preLoading,
      saveAudioTime,
      paperNo,
      Timer,
      timeText,
      finishExam,
      audioUrl,
      itemNo,
      paperInfo,
      cache,
      setAnswer,
      setcache,
      getPaper,
      audioStatus,
      audioPlay,
      Loading,
      audioEnded,
      setAudioStatus,
      updateCache,
      content,
      setCountDown
    };
  }
};
//流程控制(倒计时，交卷)
function useExamProcess(examInfo, content, cache, setcache, totalQuestion, paperNo) {
  let countDownTimer;
  let checkTimeFlag = false;
  let countTimer;
  let timeText = ref("00:00:00");
  onBeforeUnmount(() => {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
  });
  //启动倒计时
  function setCountDown() {
    let time = cache.remaining || examInfo.remainingTime;
    //计时器
    countDownTimer = new WebSocket("wss://unilearn.fltrp.com/jzws/count-down");
    countDownTimer.onopen = () => {
      countDownTimer.send(time + ":1:" + examInfo.userId);
    };
    countDownTimer.onmessage = evt => {
      time = evt.data;
      if (time <= 0) {
        finishExam(2);
      } else {
        let s = time % 60;
        let m = parseInt(time / 60) % 60;
        let h = parseInt(parseInt(time / 60) / 60);
        timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${s > 9 ? s : "0" + s}`;
        cache.remaining = time;
        cache.paperTime[paperNo.value] ? cache.paperTime[paperNo.value]++ : cache.paperTime[paperNo.value] = 1;
        //自动缓存(30s)
        if (time % 30 == 0) {
          setcache();
        }
        //倒计时提示
        if (time == 300) {
          ElMessage({
            type: "warning",
            showClose: true,
            message: "距离考试结束仅有5分钟"
          });
        }
      }
    };
    countDownTimer.onclose = e => {
      if (!e.wasClean && window.navigator.onLine && countDownTimer && countDownTimer.readyState != 0) {
        countDownTimer.close();
        setCountDown();
      }
    };
  }

  // function setCountDown() {
  //   if (countTimer) clearInterval(countTimer);
  //   let time = cache.remaining || examInfo.remainingTime;
  //   countTimer = setInterval(() => {
  //     time--;
  //     if (time <= 0) {
  //       finishExam(2);
  //     } else {
  //       let s = time % 60;
  //       let m = parseInt(time / 60) % 60;
  //       let h = parseInt(parseInt(time / 60) / 60);
  //       timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${
  //         s > 9 ? s : "0" + s
  //       }`;
  //       cache.remaining = time;
  //       cache.paperTime[paperNo.value]
  //         ? cache.paperTime[paperNo.value]++
  //         : (cache.paperTime[paperNo.value] = 1);
  //       //自动缓存(30s)
  //       if (time % 30 == 0) {
  //         setcache();
  //       }
  //       //倒计时提示
  //       if (time == 300) {
  //         ElMessage({
  //           type: "warning",
  //           showClose: true,
  //           message: "距离考试结束仅有5分钟",
  //         });
  //       }
  //     }
  //   }, 1000);
  //   //计时器
  // }
  //倒计时验证
  function checkTime() {
    let checkNum = cache.remaining;
    setTimeout(() => {
      if (checkTimeFlag) {
        if (checkNum == cache.remaining) {
          setcache();
          ElMessageBox.confirm(`当前检测到作答出现异常，请刷新页面继续作答，我们会保存你之前的作答记录`, "", {
            showClose: false,
            confirmButtonText: "确认",
            showCancelButton: false,
            type: "warning"
          }).then(() => {
            window.location.reload();
          }).catch(() => {
            window.location.reload();
          });
        } else {
          checkTime();
        }
      }
    }, 20000);
  }
  //交卷(1手动交卷 2倒计时结束被交卷 3提交分卷)
  function finishExam(type) {
    if (type == 1) {
      //前置判断
      if (examInfo.totalTime - cache.remaining < 300) {
        ElMessageBox.confirm(`该部分作答五分钟后才可以提交`, "", {
          showClose: false,
          showCancelButton: false,
          cancelButtonText: false,
          type: "warning"
        });
        return 0;
      }
      //计算题目
      let questCount = 0;
      for (let key in cache.answers) {
        if (cache.answers[key] || cache.answers[key] === 0) {
          questCount++;
        }
      }
      if (questCount < totalQuestion.value) {
        ElMessageBox.confirm(`还有${totalQuestion.value - questCount}题未作答，确认交卷吗？`, "", {
          showClose: false,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          finishExamApi(1);
        });
      } else {
        ElMessageBox.confirm(`确认交卷吗？`, "", {
          showClose: false,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          finishExamApi(1);
        });
      }
    } else if (type == 2) {
      finishExamApi(2);
    } else if (type == 3) {
      ElMessageBox.confirm(`本部分提交后不能返回修改，确认提交吗？`, "", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        finishExamApi(1, 1);
      }).catch(() => {});
    }
  }
  function finishExamApi(submit, syncScore) {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
    checkTimeFlag = false;
    let data = {
      answers: {
        ...cache.answers
      },
      remaining: cache.remaining,
      paperTime: cache.paperTime,
      examId: examId,
      submit: submit,
      syncScore: syncScore ? syncScore : 0
    };
    const loading = ElLoading.service({
      lock: true,
      text: "正在提交考试..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    SubmitExamApi({
      ...data
    }).then(r => {
      if (r.status < 400) {
        ElMessage({
          type: "success",
          showClose: true,
          message: "提交成功"
        });
        setTimeout(() => {
          loading.close();
          if (submit == 1) {
            content.emit("finishExam", {
              ...r.data
            });
          } else {
            content.emit("finishExam");
          }
        }, 1000);
      } else {
        loading.close();
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  //分卷时间

  return {
    timeText,
    setCountDown,
    finishExam,
    checkTime
  };
}
//获取试卷
function usePaper(paperInfo, totalQuestion, examInfo, store) {
  //获取试卷
  function getPaper(paperIds, setCountDown, preLoad) {
    paperInfo.push(...examInfo.papers);
    paperInfo.forEach(item => {
      item.items[0].itemAttributeList.some(attribute => {
        if (attribute.itemAttributeName == "skill") {
          if (attribute.itemAttributeValue.length > 2) {
            item.skill = store.state.skillText[attribute.itemAttributeValue];
          } else {
            item.skill = attribute.itemAttributeValue;
          }
          return true;
        }
      });
    });
    totalQuestion.value = useSettingPaper(paperInfo);
    // 是否存在听力卷
    for (let i = 0; i < paperInfo.length; i++) {
      if (paperInfo[i].skill == "S1") {
        preLoad();
        return 0;
      }
    }
    setCountDown();
  }
  return {
    getPaper
  };
}
//目录
function useSettingPaper(paperInfo) {
  let task = 1;
  let taskNo = 0;
  paperInfo.forEach(paperItem => {
    paperItem.items.forEach(items => {
      items.menu = task;
      items.questionGroupList.forEach(group => {
        group.questionList.forEach(questionItem => {
          if (questionItem.questionScore) {
            task++;
            taskNo++;
          }
        });
      });
      //mm的分类
      if (items.questionGroupList[0].questionMethod == "mm") {
        //选择题展示
        if (items.questionGroupList[0].questionList[0].questionStem.split(" ").length > 2) {
          items.questionGroupList[0].questionMethod = "mm-mcq";
        } else if (items.questionGroupList[0].choiceList[0].choiceText.split(" ").length > 1) {
          items.questionGroupList[0].questionMethod = "mm-drag";
        }
      } else if (items.questionGroupList[0].questionMethod == "mcq") {
        items.questionGroupList.forEach(questionItem => {
          if (questionItem.choiceList.length == 2) {
            questionItem.questionMethod = "judge";
          }
        });
      }
    });
  });
  return taskNo;
}
//缓存 答案
function useAnswer(cache, getPaper, examInfo, itemNo, paperNo, netState, content) {
  let time = null;
  //获取缓存
  function getResume(setCountDown, preLoad) {
    const loading = ElLoading.service({
      lock: true,
      text: "获取作答数据..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    GetResumeApi(examId).then(r => {
      loading.close();
      if (r.status < 400) {
        Object.assign(cache, r.data);
        //题号
        cache.audioOver = [];
        if (cache.interruptMark) {
          cache.interruptMark = JSON.parse(cache.interruptMark);
          itemNo.value = cache.interruptMark.itemNo || 0;
          paperNo.value = cache.interruptMark.paperNo || 0;
          cache.audioOver = cache.interruptMark.audioOver || [];
        }
        cache.paperTime ? "" : cache.paperTime = [0, 0, 0, 0];
        getPaper(examInfo.paperIds, setCountDown, preLoad);
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  //设置答案
  function setAnswer(msg) {
    for (let key in msg) {
      cache.answers[key] = msg[key];
    }
  }
  //设置缓存
  function setcache() {
    let data = {
      answers: {
        ...cache.answers
      },
      audios: {
        ...cache.audios
      },
      remaining: cache.remaining,
      paperTime: cache.paperTime,
      examId: examId,
      //题号
      interruptMark: {
        itemNo: itemNo.value,
        paperNo: paperNo.value,
        audioOver: cache.audioOver
      }
    };
    //防重复提交
    if (time == data.remaining) {
      return 0;
    } else {
      time = data.remaining;
    }
    if (netState) {
      window.localStorage.removeItem("cache-" + examId);
      SetResumeApi(data).then(r => {
        // if (r.status == 404) {
        //   ElMessage({
        //     type: "error",
        //     showClose: true,
        //     message: "您的考试已被强制提交。",
        //   });
        //   content.emit("finishExam");
        // } else
        if (r.status == 406) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的考试已被重置。"
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (r.status == 403) {
          ElMessage({
            type: "error",
            showClose: true,
            message: "您的登录已失效或在别处登录"
          });
          setTimeout(() => {
            window.closed();
          }, 2000);
        }
      });
    } else {
      data.interruptMark ? data.interruptMark = JSON.stringify(data.interruptMark) : "";
      window.localStorage.setItem("cache-" + examId, JSON.stringify(data));
    }
  }
  return {
    setAnswer,
    setcache,
    getResume
  };
}
//播放器
function useAudio(paperInfo, itemNo, cache, setcache, paperNo) {
  let audioStatus = ref("yet");
  let audioTimer;
  let audioObjList = [];
  let paperNo_S1 = ref(0);
  //预加载
  let preLoading = ref(false);
  let preLoadingText = ref(0);
  //是否存在听力考试
  let isAudio = false;
  function preLoad(index = 0, page = null) {
    if (index == 0) {
      // 是否存在听力卷
      for (let i = 0; i < paperInfo.length; i++) {
        if (paperInfo[i].skill == "S1") {
          page = i;
          paperNo_S1.value = i;
          isAudio = true;
          break;
        }
      }
      console.log(page);
      if (page == null) {
        return 0;
      } else {
        preLoading.value = true;
        preLoadingText.value = 0;
      }
    }
    if (paperInfo[page].items.length == index) {
      return 0;
    } else {
      let item = paperInfo[page].items[index];
      let url = item.mediaName.indexOf("http") == -1 ? audioUrl + item.mediaName : item.mediaName;
      let audio = new Audio();
      //播放进度
      let currentTime = cache.audios[item.itemId] || 0.1;
      audio.currentTime = currentTime;
      audio.src = url;
      audioObjList.push(audio);
      document.getElementById("app").appendChild(audio);
      audio.load();
      audio.onended = () => audioEnded();
      audio.oncanplaythrough = () => {
        preLoadingText.value = index + 1;
        preLoad(index + 1, page);
      };
    }
  }
  //播放
  function audioPlay() {
    //当前题目
    let audio = audioObjList[itemNo.value] ? audioObjList[itemNo.value] : audioObjList[0];
    //获取播放时间

    audio.play();
    audioStatus.value = "ing";
    updateCache();
  }
  //播放结束
  function audioEnded() {
    clearInterval(audioTimer);
    audioStatus.value = "over";
    let audio = audioObjList[itemNo.value] ? audioObjList[itemNo.value] : audioObjList[0];
    cache.audios[paperInfo[paperNo.value].items[itemNo.value].itemId] = audio.duration;
    cache.audioOver.push(paperInfo[paperNo.value].items[itemNo.value].itemId);
  }
  //音频播放状态
  function setAudioStatus() {
    if (audioStatus.value != "loading") return 0;
    //加载完成后判断听力是否结束
    // let audio =let audio = audioObjList[itemNo.value];;
    // let currentTime =
    //   cache.audios[paperInfo[paperNo.value].items[itemNo.value].itemId];
    nextTick(() => {
      if (cache.audioOver.indexOf(paperInfo[paperNo.value].items[itemNo.value].itemId) == -1) {
        audioStatus.value = "yet";
      } else {
        audioStatus.value = "over";
      }
    });
  }
  //定时修改缓存
  function updateCache() {
    //控制不会时间不会存入倒退值
    let currentTime = cache.audios[paperInfo[paperNo.value].items[itemNo.value].itemId] || 0.1;
    //播放中
    audioTimer = setInterval(() => {
      if (audioStatus.value == "ing") {
        cache.audios[paperInfo[paperNo.value].items[itemNo.value].itemId] = currentTime;
        currentTime += 3;
        setcache();
      } else {
        clearInterval(audioTimer);
      }
    }, 3000);
  }
  //更新进度
  function saveAudioTime() {
    if (!isAudio) return 0;
    let audio = audioObjList[itemNo.value] ? audioObjList[itemNo.value] : audioObjList[0];
    //获取播放时间
    let currentTime = audio.currentTime || cache.audios[paperInfo[paperNo.value].items[itemNo.value].itemId] || 0.1;
    cache.audios[paperInfo[paperNo.value].items[itemNo.value].itemId] = currentTime;
  }

  //更换题目时，更新播放状态
  watch(itemNo, () => {
    clearInterval(audioTimer);
    if (audioObjList[itemNo.value]) {
      if (cache.audioOver.indexOf(paperInfo[paperNo.value].items[itemNo.value].itemId) == -1) {
        audioStatus.value = "yet";
      } else {
        audioStatus.value = "over";
      }
      audioObjList.forEach(item => {
        item.pause();
      });
    }
  }, {
    immediate: true
  });
  watch(paperNo, () => {
    //更改状态
    clearInterval(audioTimer);
    if (audioObjList[itemNo.value]) {
      if (cache.audioOver.indexOf(paperInfo[paperNo.value].items[itemNo.value].itemId) == -1) {
        audioStatus.value = "yet";
      } else {
        audioStatus.value = "over";
      }
      audioObjList.forEach(item => {
        item.pause();
      });
    }
  }, {
    immediate: true
  });
  return {
    paperNo_S1,
    preLoadingText,
    preLoading,
    preLoad,
    audioStatus,
    audioPlay,
    audioEnded,
    setAudioStatus,
    updateCache,
    saveAudioTime
  };
}